import React from 'react';
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';
import { CheckCircleIcon, UserPlusIcon, XMarkIcon } from '@heroicons/react/24/solid';
import { preferenceOptions, toReadableFormat } from '../CRM/customerPreferences';


export const CustomerCreationModal = ({ showModal, closeModal,  handleSubmit, formState, setFormState, handleInputChange, isEditing, isSuccess, agents, isReferred, setIsReferred, setShowModal }) => {

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormState(prevState => ({
      ...prevState,
      preferences: checked
        ? [...prevState.preferences, name]
        : prevState.preferences.filter(preference => preference !== name)
    }));
  };





  return (
    <Transition show={showModal} as={React.Fragment}>
    <Dialog
        as="div"
        className="relative z-50"
        onClose={closeModal}
    >
      <TransitionChild
        as={React.Fragment}
        enter="ease-out duration-300"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="fixed inset-0 bg-gradient-to-br from-gray-900/80 via-gray-900/70 to-gray-900/80 backdrop-blur-sm" />
      </TransitionChild>

      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center">
          <TransitionChild
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100 scale-100"
          leaveTo="opacity-0 scale-95"
        >
        <DialogPanel className="w-full max-w-4xl transform overflow-hidden text-left align-middle transition-all bg-white shadow-2xl rounded-2xl">
          {/* Header with gradient background */}
          <div className="relative bg-gradient-to-r from-blue-600 via-blue-500 to-indigo-600 px-8 py-6">
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 text-white/80 hover:text-white hover:bg-white/20 rounded-lg p-2 transition-all duration-200"
            >
              <XMarkIcon className="h-6 w-6" />
            </button>
            <Dialog.Title
              as="h3"
              className="text-3xl font-bold text-white flex items-center gap-3"
            >
              <div className="bg-white/20 backdrop-blur-sm p-3 rounded-xl">
                <UserPlusIcon className="h-8 w-8 text-white" />
              </div>
              {isEditing ? 'Edit Customer' : 'Create New Customer'}
            </Dialog.Title>
            <p className="mt-2 text-blue-100 text-sm">
              {isEditing ? 'Update customer information below' : 'Fill in the details to add a new customer to your system'}
            </p>
          </div>

          {isSuccess ? (
            <div className="flex flex-col items-center justify-center py-12 px-8">
              <div className="bg-green-100 rounded-full p-4 mb-4">
                <CheckCircleIcon className="h-16 w-16 text-green-600" />
              </div>
              <p className="text-2xl font-semibold text-gray-800 mb-2">Success!</p>
              <p className="text-lg text-gray-600">Customer added successfully</p>
            </div>
          ) : (
            <div className="px-8 py-6">
              <form onSubmit={handleSubmit} className="flex flex-wrap -mx-3">
              <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">

                <div className='mb-5 mt-2'>
                <label htmlFor="firstName" className="block text-sm font-semibold text-gray-700 mb-2">First Name</label>
                <input name="firstName" required onChange={handleInputChange} value={formState.firstName} placeholder="Enter first name"  className="block w-full px-4 py-3 rounded-lg border border-gray-300 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-400 bg-gray-50 focus:bg-white" />
                </div>

                <div className='mb-5'>
                <label htmlFor="lastName" className="block text-sm font-semibold text-gray-700 mb-2">Last Name</label>
                <input name="lastName" required onChange={handleInputChange} value={formState.lastName}  placeholder="Enter last name"   className="block w-full px-4 py-3 rounded-lg border border-gray-300 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-400 bg-gray-50 focus:bg-white" />
                </div>

                <div className="mb-5">
                  <label className="block text-sm font-semibold text-gray-700 mb-3">Customer Type</label>
                  <div className="flex gap-4">
                    <label className="flex items-center px-4 py-3 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-blue-400 transition-all duration-200 flex-1">
                      <input type="radio" name="customerType" value="Private" required onChange={handleInputChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"/>
                      <span className="ml-3 text-gray-700 font-medium">Private</span>
                    </label>
                    <label className="flex items-center px-4 py-3 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-blue-400 transition-all duration-200 flex-1">
                      <input type="radio" name="customerType" value="Corporate" required onChange={handleInputChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"/>
                      <span className="ml-3 text-gray-700 font-medium">Corporate</span>
                    </label>
                  </div>
                </div>

                <div className='mb-5'>
                <label htmlFor="dateOfBirth" className="block text-sm font-semibold text-gray-700 mb-2">Date of Birth</label>
                <input type="date" name="dateOfBirth" value={formState.dateOfBirth} required onChange={handleInputChange}
                className="block w-full px-4 py-3 rounded-lg border border-gray-300 text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-400 bg-gray-50 focus:bg-white" />
                </div>

                <div className='mb-5'>
                <label htmlFor="phoneNumber" className="block text-sm font-semibold text-gray-700 mb-2">Phone Number</label>
                <input name="phoneNumber" required onChange={handleInputChange} value={formState.phoneNumber} placeholder="Enter phone number" className="block w-full px-4 py-3 rounded-lg border border-gray-300 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-400 bg-gray-50 focus:bg-white" />
                </div>

                <div className="mb-5">
                  <label className="block text-sm font-semibold text-gray-700 mb-3">Gender</label>
                  <div className='flex gap-3'>
                    <label className="flex items-center px-4 py-3 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-blue-400 transition-all duration-200 flex-1">
                      <input type="radio" name="gender" value="Male" required onChange={handleInputChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" />
                      <span className="ml-3 text-gray-700 font-medium">Male</span>
                    </label>
                    <label className="flex items-center px-4 py-3 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-blue-400 transition-all duration-200 flex-1">
                      <input type="radio" name="gender" value="Female" required onChange={handleInputChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" />
                      <span className="ml-3 text-gray-700 font-medium">Female</span>
                    </label>
                    <label className="flex items-center px-4 py-3 border-2 border-gray-200 rounded-lg cursor-pointer hover:border-blue-400 transition-all duration-200 flex-1">
                      <input type="radio" name="gender" value="Other" required onChange={handleInputChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" />
                      <span className="ml-3 text-gray-700 font-medium">Other</span>
                    </label>
                  </div>
                </div>

                <div className='mb-5'>
                <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2">Email Address</label>
                <input name="email" type='email' required onChange={handleInputChange} value={formState.email} placeholder="Enter email address"
                 className="block w-full px-4 py-3 rounded-lg border border-gray-300 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-400 bg-gray-50 focus:bg-white" />
                </div>

                <div className='mb-5'>
                <label htmlFor="address" className="block text-sm font-semibold text-gray-700 mb-2">Customer Address</label>
                <input name="address" required onChange={handleInputChange} value={formState.address} placeholder="Enter full address"
                 className="block w-full px-4 py-3 rounded-lg border border-gray-300 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-400 bg-gray-50 focus:bg-white"/>
                </div>

               <div className='mb-5'>
               <label htmlFor="specialNotes" className="block text-sm font-semibold text-gray-700 mb-2">Special Notes</label>
                <textarea
                name="specialNotes"
                onChange={handleInputChange}
                value={formState.specialNotes}
                placeholder="Add any special notes or requirements..."
                className="block w-full px-4 py-3 rounded-lg border border-gray-300 text-gray-900 placeholder:text-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-400 bg-gray-50 focus:bg-white resize-none"
                rows="6" >
                </textarea>
                </div>
               


              </div>

              <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">

                <div className='mb-5'>
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-5 border border-blue-100">
                  <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center gap-2">
                    <span className="bg-blue-500 text-white px-2 py-1 rounded text-xs">Preferences</span>
                    Customer Preferences
                  </h3>
                {Object.entries(preferenceOptions).map(([category, options]) => (
                  <div key={category} className="mb-4 last:mb-0">
                    <h4 className="font-semibold text-gray-700 mb-2 text-sm uppercase tracking-wide">{toReadableFormat(category)}</h4>
                    <div className="space-y-2">
                    {options.map((option) => (
                      <label key={option} className="flex items-center px-3 py-2 bg-white rounded-lg hover:bg-blue-50 transition-colors duration-200 cursor-pointer border border-gray-200">
                        <input
                          type="checkbox"
                          name={option}
                          checked={formState.preferences ? formState.preferences.includes(option) : false}
                          onChange={handleCheckboxChange}
                          className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                        />
                        <span className="ml-3 text-sm text-gray-700">{option}</span>
                      </label>
                    ))}
                    </div>
                  </div>
                ))}
                </div>
                </div>
                
                <div className="mb-5">
                  <label className="flex items-center px-4 py-3 bg-white rounded-lg hover:bg-blue-50 transition-colors duration-200 cursor-pointer border-2 border-gray-200">
                    <input
                      type="checkbox"
                      onChange={(e) => setIsReferred(e.target.checked)}
                      checked={isReferred}
                      className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <span className="ml-3 text-sm font-semibold text-gray-700">Referred Customer?</span>
                  </label>
                </div>
                {isReferred && (
                  <div className="mb-5">
                    <label htmlFor="agentId" className="block text-sm font-semibold text-gray-700 mb-2">Referring Agent</label>
                    <select
                      name="agentId"
                      required
                      onChange={handleInputChange}
                      value={formState.agentId}
                      className="block w-full px-4 py-3 rounded-lg border border-gray-300 text-gray-900 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 hover:border-gray-400 bg-gray-50 focus:bg-white"
                    >
                      <option value="">Select an agent</option>
                      {agents.map((agent) => (
                        <option key={agent.id} value={agent.id}>
                          {agent.name}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

          </div>

                {/* Action Buttons */}
                <div className="flex gap-4 pt-6 border-t border-gray-200">
                  <button
                    type="submit"
                    className="flex-1 relative px-6 py-3.5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-semibold rounded-xl
                    hover:from-blue-700 hover:to-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
                    transform transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] shadow-lg hover:shadow-xl"
                  >
                    <span className="relative z-10">{isEditing ? 'Save Changes' : 'Create Customer'}</span>
                  </button>

                  <button
                    type="button"
                    className="px-6 py-3.5 bg-gray-100 text-gray-700 font-semibold rounded-xl
                    hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400
                    transform transition-all duration-200 hover:scale-[1.02] active:scale-[0.98]"
                    onClick={closeModal}
                  >
                    Cancel
                  </button>
                </div>

              </form>
            </div>
          )}
        </DialogPanel>
        </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
    );
};


